<template>
  <header class="sub-header-section" :class="{ 'sub-header-section--has-back-link': hasBackLink }">
    <button
      v-if="hasBackLink"
      type="button"
      class="atom-input-btn sub-header-section__back-link"
      @click="pageBack"
    >
      <img :src="require('@/assets/img/icon/icon_chevron_left_18.svg')" alt="" />
    </button>
    <h2 class="sub-header-section__title">{{ pageTitle }}</h2>
  </header>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
/**
 * マイページ会員情報編集画面ヘッダーセクション
 */
export default defineComponent({
  name: 'MypageUserEditHeaderSection',
  props: {
    /**
     * ページタイトル
     */
    pageTitle: {
      type: String,
      default: '',
    },
    /**
     * ページタイトル
     */
    hasBackLink: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    pageBack() {
      /**
       * 戻るボタン
       */
      this.$emit('page-back')
    },
  },
})
</script>

<style lang="scss" scoped>
.sub-header-section {
  position: relative;
  z-index: 2;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: $subHeaderPaneHeight;
  padding: 0 min(#{convertPXtoVW(8)}, 24px);
  margin: 0 auto;
  background: $white;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 5%);

  &--has-back-link {
    justify-content: space-between;

    &::after {
      display: block;
      content: '';
      width: 28px;
    }
  }

  &__back-link {
    width: 28px;
  }

  &__title {
    @include fontSetTextMedium();

    font-weight: 700;
    color: $black20;
  }
}
</style>
